import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { motion } from 'framer-motion';
export const OfferStack = () => {
  const tomos = [{
    num: 1,
    title: 'POR QUÉ TU CABEZA NO PARA A LA NOCHE',
    desc: 'Entendé exactamente qué te está pasando para que nada de lo que venga después sea un misterio.',
    valor: '$5.000'
  }, {
    num: 2,
    title: 'CÓMO SACARTE DE LA CABEZA LO QUE TE QUEDA DANDO VUELTAS',
    desc: 'El paso a paso de la Descarga. Para vaciar pensamientos, pendientes y preocupaciones antes de dormir.',
    valor: '$5.000'
  }, {
    num: 3,
    title: 'QUÉ HACER EN EL MOMENTO CUANDO NO PODÉS DORMIR',
    desc: 'El protocolo completo para cuando ya estás en la cama y tu cabeza no para.',
    valor: '$5.000'
  }, {
    num: 4,
    title: 'CÓMO CORTAR LOS PENSAMIENTOS QUE TE EMPEORAN TODO',
    desc: 'Frenás ideas como "mañana voy a estar destruido" o "nunca voy a poder dormir bien".',
    valor: '$5.000'
  }, {
    num: 5,
    title: 'CÓMO LLEGAR A LA NOCHE MENOS PASADO DE VUELTAS',
    desc: 'Porque muchas veces el problema empieza durante el día. Este tomo te muestra cómo llegar más tranquilo.',
    valor: '$5.000'
  }, {
    num: 6,
    title: 'CÓMO ARMAR TU PROPIA FORMA DE DORMIR MEJOR',
    desc: 'Juntás todo y armás tu sistema personal. Para siempre. Sin probar cosas al azar.',
    valor: '$5.000'
  }];
  const bonuses = [{
    num: 1,
    title: 'CÓMO VOLVERTE A DORMIR SI TE DESPERTÁS EN MEDIO DE LA NOCHE',
    desc: 'Para no arruinar toda la noche cuando abrís los ojos a las 2 o 3 AM.',
    img: 'https://images.unsplash.com/photo-1506880018603-83d5b814b5a6?w=300&q=80'
  }, {
    num: 2,
    title: 'QUÉ DECIRTE CUANDO TU CABEZA EMPIEZA A ASUSTARTE',
    desc: 'Frases simples y directas para cortar pensamientos de miedo, culpa o desesperación.',
    img: 'https://images.unsplash.com/photo-1512820790803-83ca734da794?w=300&q=80'
  }, {
    num: 3,
    title: 'PLAN DE 21 DÍAS PARA DEJAR DE TERMINAR TODAS LAS NOCHES IGUAL',
    desc: 'Una guía práctica para aplicar todo en orden y notar cambios reales.',
    img: 'https://images.unsplash.com/photo-1497633762265-9d179a990aa6?w=300&q=80'
  }];
  return <Section id="oferta" data-id="element-139">
      <div className="max-w-5xl mx-auto" data-id="element-140">
        <h2 className="text-4xl md:text-5xl font-bold text-center mb-16 text-white" data-id="element-141">
          Todo lo que recibís hoy
        </h2>

        <div className="mb-20" data-id="element-142">
          <h3 className="text-2xl font-bold text-white mb-8 border-b border-night-700 pb-4" data-id="element-143">
            📚 LOS 6 TOMOS
          </h3>

          <div className="grid md:grid-cols-2 gap-4" data-id="element-144">
            {tomos.map(tomo => <motion.div key={tomo.num} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-night-800 p-6 rounded-xl border border-night-700" data-id="element-145">
                <div className="text-accent-blue font-bold text-xs tracking-wider mb-2" data-id="element-146">
                  TOMO {tomo.num}
                </div>
                <h4 className="text-lg font-bold text-white mb-2 leading-tight" data-id="element-147">
                  {tomo.title}
                </h4>
                <p className="text-gray-400 text-sm mb-3" data-id="element-148">{tomo.desc}</p>
                <div className="text-gray-500 text-xs font-medium line-through" data-id="element-149">
                  Valor: {tomo.valor}
                </div>
              </motion.div>)}
          </div>
        </div>

        <div className="mb-20" data-id="element-150">
          <h3 className="text-2xl font-bold text-white mb-8 border-b border-night-700 pb-4 flex items-center gap-3" data-id="element-151">
            🎁 3 REGALOS EXCLUSIVOS
          </h3>

          <div className="grid md:grid-cols-3 gap-6" data-id="element-152">
            {bonuses.map((bonus, idx) => <motion.div key={bonus.num} initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.1
          }} className="bg-night-800 rounded-2xl border border-night-700 overflow-hidden relative group" data-id="element-153">
                <div className="absolute top-3 right-3 bg-green-500 text-white text-xs font-bold px-3 py-1 rounded-full z-10 shadow-lg" data-id="element-154">
                  GRATIS
                </div>

                <div className="aspect-video relative overflow-hidden" data-id="element-155">
                  <div className="absolute inset-0 bg-night-900/20 group-hover:bg-transparent transition-colors z-10" data-id="element-156" />
                  <img src={bonus.img} alt={bonus.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" data-id="element-157" />
                </div>

                <div className="p-6" data-id="element-158">
                  <div className="text-accent-blue font-bold text-xs tracking-wider mb-2" data-id="element-159">
                    BONUS {bonus.num}
                  </div>
                  <h4 className="text-lg font-bold text-white mb-3 leading-tight" data-id="element-160">
                    {bonus.title}
                  </h4>
                  <p className="text-gray-400 text-sm" data-id="element-161">{bonus.desc}</p>
                </div>
              </motion.div>)}
          </div>
        </div>

        <div className="text-center max-w-2xl mx-auto" data-id="element-162">
          <div className="text-gray-400 text-xl mb-4 font-medium" data-id="element-163">
            Valor total: <span className="line-through" data-id="element-164">$39.000</span>
          </div>

          <Button href="#compra" fullWidth className="py-5 text-xl" data-id="element-165">
            SÍ, QUIERO TODO ESTO POR $19.999
          </Button>
        </div>
      </div>
    </Section>;
};